// extracted by mini-css-extract-plugin
export default {"backdrop":"Loader_backdrop__zxNHN","inlineLoader":"Loader_inlineLoader__WoFiG","spinner":"Loader_spinner__BbgA-","spin":"Loader_spin__jBkhk"};